"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nTestInstance = void 0;
var tslib_1 = require("tslib");
var i18next_1 = tslib_1.__importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
function i18nTestInstance() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, i18next_1.default.use(react_i18next_1.initReactI18next).init({
                        fallbackLng: 'en',
                        lng: 'en',
                        ns: ['translations'],
                        defaultNS: 'translations',
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, i18next_1.default];
            }
        });
    });
}
exports.i18nTestInstance = i18nTestInstance;
//# sourceMappingURL=I18n.js.map